export default from './ProfileVideo';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/ProfileVideo/index.js